import React from "react";
import PageConverter from "../../Function/PageConverter";
import jsonData from "./RegisterCandidate.json";

const RegisterCandidate = () => {
  


  return (
    <>
      <PageConverter jsonData={jsonData} />
    </>
  );
};

export default RegisterCandidate;
